
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/data-strategy",
      function () {
        return require("private-next-pages/solutions/data-strategy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/data-strategy"])
      });
    }
  